import React, { Component } from "react";
import fbIcon from "../images/fb_icon.png";
import insIcon from "../images/instagram_icon.png";
import youtubeIcon from "../images/youtube_icon.png";
import viberIcon from "../images/viber_icon.png";
import toTopIcon from "../images/arrow-up.svg";

import { withTranslation } from "react-i18next";
import mapPinIcon from "../images/map_pin_icon.png";
import emailIcon from "../images/mail_icon.png";
import phoneIcon from "../images/phone_icon.png";
import clockIcon from "../images/clock_icon.png";
import FooterExportMenu from "./CustomMenu/FooterExportMenu";

class Footer extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="footer uk-section">
        <hr />
        <footer className="uk-container">
          <div className="uk-flex uk-flex-between uk-flex-wrap">
            <div className="uk-width-1-1 uk-width-1-4@m">
              <div className="footer-contacts uk-text-center uk-text-left@m">
                <h4>{t("footer.contacts.info")}</h4>
                <ul className="uk-list">
                  
                  <li>
                    <img className="footer-contacts__icon" src={mapPinIcon} />
                   {t("shop.street_stok")}
                  </li>
                  <li>
                    <img className="footer-contacts__icon" src={emailIcon} />
                    <a href="mailto:goodel.sumy@gmail.com">goodel.sumy@gmail.com</a>
                  </li>
                 
                  <li>
                    <img className="footer-contacts__icon" src={phoneIcon} />
                    <a href="tel:+380500107128">050-010-71-28</a>
                  </li>
                  <li>
                    <img className="footer-contacts__icon" src={phoneIcon} />
                    <a href="tel:+380500289909">050-028-99-09</a>
                  </li>
                  <li>
                    <img className="footer-contacts__icon" src={clockIcon} />
                    {t("shop.workDays")}
                  </li>
                </ul>
              </div>
            </div>
            <div className="uk-width-1-1 uk-width-1-4@m uk-text-center uk-text-left@m">
              <FooterExportMenu menuName="footer_info_menu_" title= {t("footer.info_menu")} />
            </div>
            <div className="uk-width-1-1 uk-width-1-4@m uk-text-center uk-text-left@m">
              <FooterExportMenu menuName="footer-services-menu-" title= {t("footer.services_menu")} />
            </div>
            <div className="footer-social uk-text-center uk-width-1-1 uk-width-1-4@m">
              {/* <h4>{t("menu.socialLinks")}</h4>
              <ul className="uk-nav uk-flex uk-flex-middle uk-flex-center">
                <li>
                  <a href="#" target="_blank" rel="noopener">
                    <img
                      alt={"viber"}
                      className="social-link__icon"
                      src={viberIcon}
                      uk-svg={""}
                    />
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank" rel="noopener noreferrerr">
                    <img
                      alt={"facebook"}
                      className="social-link__icon"
                      src={fbIcon}
                      uk-svg={""}
                    />
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank" rel="noopener">
                    <img
                      alt={"instagram"}
                      className="social-link__icon"
                      src={insIcon}
                      uk-svg={""}
                    />
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank" rel="noopener">
                    <img
                      alt={"youtube"}
                      className="social-link__icon"
                      src={youtubeIcon}
                      uk-svg={""}
                    />
                  </a>
                </li>
              </ul> */}
            </div>
          </div>
        </footer>
        <div className="to-top">
          <span className="to-top__btn" uk-scroll="" title={t("shop.scrolToTop")}>
            <img
              alt={""}
              className="to-top__icon"
              src={toTopIcon}
              uk-svg={""}
            />
          </span>
        </div>
      </div>
    );
  }
}
const footerTrans = withTranslation("translations")(Footer);
export default footerTrans;
